// Bootstrap

import "bootstrap/js/dist/base-component";
import "bootstrap/js/dist/alert";
import "bootstrap/js/dist/button";
import "bootstrap/js/dist/carousel";
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/modal";
import Offcanvas from "bootstrap/js/dist/offcanvas";
import "bootstrap/js/dist/popover";
import "bootstrap/js/dist/scrollspy";
import "bootstrap/js/dist/tab";
import "bootstrap/js/dist/toast";
import "bootstrap/js/dist/tooltip";

// var tooltipTriggerList = [].slice.call(
// 	document.querySelectorAll('[data-bs-toggle="tooltip"]')
// );
// var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
// 	return new bootstrap.Tooltip(tooltipTriggerEl);
// });

// var popoverTriggerList = [].slice.call(
// 	document.querySelectorAll('[data-bs-toggle="popover"]')
// );
// var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
// 	return new bootstrap.Popover(popoverTriggerEl);
// });

// Custom

// Navbar background on scroll
( function () {
	var navbar = document.getElementById( 'wrapper-navbar' );
	if ( ! navbar ) return;

	function updateNavbar() {
		navbar.classList.toggle( 'navbar-scrolled', window.scrollY > 0 );
	}

	window.addEventListener( 'scroll', updateNavbar, { passive: true } );
	updateNavbar();
} )();

// Close offcanvas nav when an anchor link is clicked
document.addEventListener( 'DOMContentLoaded', function () {
	var offcanvasEl = document.getElementById( 'navbarOffcanvas' );
	if ( ! offcanvasEl ) return;

	offcanvasEl.querySelectorAll( 'a[href^="#"]' ).forEach( function ( link ) {
		link.addEventListener( 'click', function () {
			var instance = Offcanvas.getInstance( offcanvasEl );
			if ( instance ) instance.hide();
		} );
	} );
} );

// FancyBox — full video lightbox
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

Fancybox.bind( '[data-fancybox="video"]', {
	Html: {
		videoTpl: '<video class="fancybox__html5video" playsinline controls autoplay><source src="{{src}}" type="video/mp4"></video>',
	},
	compact: false,
	animated: false,
	showClass: false,
	hideClass: false,
} );

// Inline background video — loop first 10 s
document.addEventListener( 'DOMContentLoaded', function () {
	document.querySelectorAll( '.video-lightbox__video' ).forEach( function ( video ) {
		video.addEventListener( 'timeupdate', function () {
			if ( video.currentTime >= 10 ) {
				video.currentTime = 0;
			}
		} );
	} );
} );

// Swiper — Gallery slider
import Swiper from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

document.addEventListener('DOMContentLoaded', function () {
	document
		.querySelectorAll('.wp-block-gallery.slidergallery')
		.forEach(function (gallery) {
			// Support both newer nested-image format and older ul/li format
			var items = gallery.querySelectorAll(
				'.wp-block-image, .blocks-gallery-item'
			);

			if (!items.length) return;

			// Build swiper-wrapper around the items
			var wrapper = document.createElement('div');
			wrapper.className = 'swiper-wrapper';

			items.forEach(function (item) {
				var slide = document.createElement('div');
				slide.className = 'swiper-slide';
				slide.appendChild(item);
				wrapper.appendChild(slide);
			});

			// Remove leftover ul if old format
			var oldGrid = gallery.querySelector('.blocks-gallery-grid');
			if (oldGrid) oldGrid.remove();

			var pagination = document.createElement('div');
			pagination.className = 'swiper-pagination';

			gallery.appendChild(wrapper);
			gallery.appendChild(pagination);
			gallery.classList.add('swiper');

			new Swiper(gallery, {
				modules: [Pagination, Autoplay],
				loop: true,
				autoplay: {
					delay: 2000,
					disableOnInteraction: false,
				},
				slidesPerView: 1,
				pagination: {
					el: pagination,
					clickable: true,
				},
			});
		});

	// Sponsor icons — 4 visible, scroll by 1, looping carousel
	document
		.querySelectorAll('.wp-block-gallery.sponsor-icons')
		.forEach(function (gallery) {
			var items = gallery.querySelectorAll(
				'.wp-block-image, .blocks-gallery-item'
			);

			if (!items.length) return;

			var wrapper = document.createElement('div');
			wrapper.className = 'swiper-wrapper';

			items.forEach(function (item) {
				var slide = document.createElement('div');
				slide.className = 'swiper-slide';
				slide.appendChild(item);
				wrapper.appendChild(slide);
			});

			var oldGrid = gallery.querySelector('.blocks-gallery-grid');
			if (oldGrid) oldGrid.remove();

			gallery.appendChild(wrapper);
			gallery.classList.add('swiper');

			new Swiper(gallery, {
				modules: [Autoplay],
				loop: true,
				slidesPerView: 2,
				slidesPerGroup: 1,
				spaceBetween: 24,
				autoplay: {
					delay: 2500,
					disableOnInteraction: false,
				},
				breakpoints: {
					576: { slidesPerView: 3 },
					992: { slidesPerView: 4 },
				},
			});
		});
});
